import { type IPrivateContactAlliance } from '@inpart-io/padme-iap';
import { type GetterTree } from 'vuex';

import { type IPrivateContactAllianceState } from './types';

export const GET_FROM_ALLIANCE = 'getFromAlliance';

const getPrivateContactAlliance = (_state: IPrivateContactAllianceState, ids = [] as number[]): IPrivateContactAlliance[] => {
    return ids
        .map((privateContactAllianceId: number) => {
            return _state.dataObjectList.get(privateContactAllianceId);
        })
        .filter((privateContactAlliance) => {
            return privateContactAlliance;
        });
};

export const getters: GetterTree<IPrivateContactAllianceState, unknown> = {
    [GET_FROM_ALLIANCE]: (_state: IPrivateContactAllianceState) => {
        return (allianceId: number): IPrivateContactAlliance[] | undefined => {
            return getPrivateContactAlliance(_state, _state.byAlliance.get(allianceId) ?? []);
        };
    }
};
